import { Validator } from '@vista-digital/validator';
import { defaultSeatPickerConfig, seatPickerConfigValidatorSchema } from '../../../seat-picker/types/config/config';
/**
 * Default configuration options for the Order Seat Picker component.
 */
export const defaultOrderSeatPickerConfig = Object.assign(Object.assign({}, defaultSeatPickerConfig), { messageActionButton: { show: false } });
export const orderSeatPickerConfigValidator = Validator.object(Object.assign(Object.assign({}, seatPickerConfigValidatorSchema), { messageActionButton: Validator.object({ show: Validator.boolean() }) }));
